import { createStore } from '../../lib/create-store';

import { getActions, getInitialState, getReducer } from '.';

const ACTION_PREFIX = 'PARSELY_MY_TEAM';

const initialState = getInitialState();
const reducer = getReducer(ACTION_PREFIX);

export const parselyMyTeamStore = createStore({
  initialState,
  reducer,
  name: 'parselyMyTeamStore',
});

export const parselyMyTeamActions = getActions(ACTION_PREFIX);
